import { render, staticRenderFns } from "./StockEditProductCategory.vue?vue&type=template&id=52408f7e"
import script from "./StockEditProductCategory.vue?vue&type=script&lang=js"
export * from "./StockEditProductCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports